import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import '../../styles/components/header.css';
import SvgImageLoader from '../elements/SvgImageLoader';

class Header extends Component {
    render() {
        return (
            <header className="header">
                <SvgImageLoader
                  svg={this.props.svg}
                  image={this.props.image}
                  className="header__image"
                  alt={this.props.title}
                />
                <div className="header__background">{this.props.title}</div>
                <div className="container container--large header__container">
                    <div className="header__text">
                        <h1 className="header__title">{this.props.title}</h1>
                        <p className="header__subtitle">{this.props.subtitle}</p>
                    </div>
                </div>
            </header>
        );
    }

    updateOriginOnMove(e) {
        let elementToMove = document.getElementsByClassName('header')[0];
        if(getComputedStyle(elementToMove).perspective !== 'none') {
            window.requestAnimationFrame(() => {
                var x = e.clientX + 20,
                    y = e.clientY + 20,
                    w = elementToMove.offsetWidth,
                    h = elementToMove.offsetHeight;
                elementToMove.style.perspectiveOrigin = ((x / w) * 100) + "% " + ((y / h) * 100) + "%";
            });
        }
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.updateOriginOnMove, 0);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.updateOriginOnMove);
    }
}

const mapStateToProps = state => {
    return {
        header: state.header
    }
};

export default connect(mapStateToProps)(withRouter(Header));



// WEBPACK FOOTER //
// ./src/js/components/Header.js